// src/ManagePrices.js
import React, { useState, useEffect } from "react";
import { database, ref, push, remove, onValue, update } from "./firebase";
import "./BillingSystem.css";
import BossNavigation from "./BossNavigation";

export default function ManagePrices() {
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({ name: "", rate: "" });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const productsRef = ref(database, "products");
    onValue(productsRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setProducts(Object.keys(data).map((id) => ({ id, ...data[id] })));
      }
    });
  }, []);

  const handleSubmit = () => {
    if (!form.name || !form.rate) {
      alert("Please enter both name and rate.");
      return;
    }

    if (editId) {
      update(ref(database, "products/" + editId), form);
      setEditId(null);
    } else {
      push(ref(database, "products"), form);
    }

    setForm({ name: "", rate: "" });
  };

  const handleEdit = (product) => {
    setForm({ name: product.name, rate: product.rate });
    setEditId(product.id);
  };

  const handleDelete = (id) => {
    remove(ref(database, "products/" + id));
  };

  return (
    <div className="history-container">
      <h2>Manage Product Prices</h2>
       <BossNavigation />

      <div className="form">
        <input
          type="text"
          placeholder="Product Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <input
          type="number"
          placeholder="Rate (₹)"
          value={form.rate}
          onChange={(e) => setForm({ ...form, rate: e.target.value })}
        />
        <button onClick={handleSubmit}>{editId ? "Update" : "Add"}</button>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Rate (₹)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td>₹{p.rate}</td>
                <td>
                  <button onClick={() => handleEdit(p)}>Edit</button>
                  <button onClick={() => handleDelete(p.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
